import React from "react";
import placeholder_image_fff from "../../../assets/placeholder_image_fff.jpg";
import MarkdownHelper from "../../utils/MarkdownHelper";
import ReactMarkdown from "react-markdown";
import {default as t} from '../../utils/Translate'

const BrandPageOffer = ({lang, partnerLogo}) => {
	const title = "Offers from the partner";
	const text1 = "__Earn miles__ Exciting offers are waiting for you";
	const text2 = "__x,xxx__";
	
	return (
		
		<section className="brandPageOffer_base mam3-type bg-white px-md py-md">
			
			<div className="brandPageOffer_headingWrapper">
				<div className="brandPageOffer_heading headline">
					<ReactMarkdown {...MarkdownHelper.headingTypes()}
					               source={t(title, lang)}
					               escapeHtml={false}/>
				</div>
			</div>
			<div className="brandPageOffer_listAllOffers ">
				<div className="offer__base">
					<div className="offer__imageRatio--169">
						<div className="offer__imageWrapper">
							<img src={placeholder_image_fff} alt="partner image"/>
						</div>
					</div>
					<div className="offer__contentWrapper">
						<div className="offer__promoContent">
							<div className="offer__partnerLogo">
								<img src={partnerLogo} alt="partner logo"/>
							</div>
							<div className="offer__logoSeparator"></div>
							<div className="offer__headingWrapper-regular">
								<div className="offer__heading-regular offer__heading_spacing">
									<div className="offer__heading-p-regular">
										<ReactMarkdown {...MarkdownHelper.headingTypes()}
										               source={t(text1, lang)}
										               escapeHtml={false}/>
									</div>
								</div>
							</div>
							<div className="offer__mainBenefitWrapper">
								<div className="offer__mainBenefit">
									<div className="offer__mainBenefitText headline">
										<ReactMarkdown {...MarkdownHelper.headingTypes()}
										               source={t(text2, lang)}
										               escapeHtml={false}/>
										<span className="mam-currency-symbol">M</span></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="offer__base">
					<div className="offer__contentWrapper">
						<div className="offer__standardContent">
							<div className="offer__partnerLogo">
								<img src={partnerLogo} alt="partner logo"/>
							</div>
							<div className="offer__textwrapper-regular">
								<div className="offer__headingWrapper-regular">
									<div className="offer__heading-regular">
										<div className="offer__heading-p-regular">
											<ReactMarkdown {...MarkdownHelper.headingTypes()}
											               source={t(text1, lang)}
											               escapeHtml={false}/>
										</div>
									</div>
								</div>
								<div className="offer__mainBenefit-regular headline">
									<ReactMarkdown {...MarkdownHelper.headingTypes()}
									               source={t(text2, lang)}
									               escapeHtml={false}/>
									<span className="mam-currency-symbol">M</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="offer__base">
					<div className="offer__contentWrapper">
						<div className="offer__standardContent">
							<div className="offer__partnerLogo">
								<img src={partnerLogo} alt="partner logo"/>
							</div>
							<div className="offer__textwrapper-regular">
								<div className="offer__headingWrapper-regular">
									<div className="offer__heading-regular">
										<div className="offer__heading-p-regular">
											<ReactMarkdown {...MarkdownHelper.headingTypes()}
											               source={t(text1, lang)}
											               escapeHtml={false}/>
										</div>
									</div>
								</div>
								<div className="offer__mainBenefit-regular headline">
									<ReactMarkdown {...MarkdownHelper.headingTypes()}
									               source={t(text2, lang)}
									               escapeHtml={false}/>
									<span className="mam-currency-symbol">M</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		
		</section>
	
	);
};


export default BrandPageOffer;



// WEBPACK FOOTER //
// ./src/components/ads/brandPage/BrandPageOffer.js